import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Typography
} from "@material-ui/core";
import { dashboardStyle } from "./style";
import getParameterByName from "../../../../Functions/functions";


const useStyles = makeStyles(dashboardStyle);
const edit = getParameterByName("edit");

const InvoiceRadioButtons = ({
  formState,
  setFormState,
  selectedRole,
  // physicalOrEInvoice,
  poBasedState,
  alignForAttachment,
}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={1}
      style={{ marginTop: "2px", padding: "0px 5px " }}
    >
      {/* {selectedRole === "IP" ||
      selectedRole === "TaxTeam" ||
      selectedRole === "I2P Initiator" ? ( */}
      {/* //  Physical/E-Invoice */}
      {/* <Grid item xs={12} sm={12}               md={alignForAttachment ? 6 : 4}
        lg={alignForAttachment ? 6 : 4}
>
          <FormControl component="fieldset">
            <FormLabel
              required
              classes={{ asterisk: classes.asterisk }}
              id="demo-row-radio-buttons-group-label"
            >
              <b>Physical/E-Invoice</b>
            </FormLabel>
            <RadioGroup
              row
              aria-label="gender"
              name="gender1"
              value={physicalOrEInvoice}
              aria-labelledby="demo-row-radio-buttons-group-label"
              // onChange={(e) => setPhysicalOrEInvoice(e.target.value)}
            >
              <FormControlLabel
                value="Physical"
                control={<Radio size="small" />}
                label="Physical"
                disabled={selectedRole === "TaxTeam" || selectedRole === "IP"}
              />
              <FormControlLabel
                value="E-Invoice"
                control={<Radio size="small" />}
                label="E-Invoice"
                disabled={selectedRole === "TaxTeam" || selectedRole === "IP"}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      ) : (
        ""
      )} */}

      {selectedRole === "IP" ||
        selectedRole === "Department Coordinator" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Buyer" ||
        selectedRole === "I2P Initiator" ? (
        <>
          {/* //  PO/ Non-PO */}
          {!formState.isLogistics && (
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 4}
              lg={alignForAttachment ? 6 : 4}
            >
              <FormControl component="fieldset">
                {/*  <FormLabel
                  classes={{ asterisk: classes.asterisk }}
                  required
                  id="demo-row-radio-buttons-group-label"
                  style={{ color: "black" }}
                >
                 <b>PO/ Non-PO</b> 
          </FormLabel>*/}
                <Typography style={{
                  color: "black", marginTop: '-15px'
                }}>
                  {edit === "true" ? <span className={classes.asterisk}>*</span> : null}

                  PO / Non-PO:
                </Typography>
                <RadioGroup
                  row
                  aria-label="gender"
                  name="gender1"
                  value={poBasedState}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                // value={value}
                // onChange={poBasedHandler}
                >
                  <FormControlLabel
                    value="PO"
                    control={<Radio size="small" />}
                    label="PO"
                    style={{ color: "black" }}
                    disabled={
                      selectedRole === "TaxTeam" ||
                      selectedRole === "IP" ||
                      selectedRole === "Buyer" ||
                      selectedRole === "Department Coordinator" ||
                      selectedRole === "Loam Approver"
                    }
                  />
                  <FormControlLabel
                    value="Non-PO"
                    control={<Radio size="small" />}
                    label="Non-PO"
                    style={{ color: "black" }}
                    disabled={
                      selectedRole === "TaxTeam" ||
                      selectedRole === "IP" ||
                      selectedRole === "Department Coordinator" ||
                      selectedRole === "Buyer" ||
                      selectedRole === "Loam Approver"
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          )}
          {/* //invoice category */}
          {/* {formState.isLogistics && ( */}
          {!formState.isLogistics &&
            poBasedState === "Non-PO" &&
            selectedRole !== "TaxTeam Initiator" &&
            selectedRole !== "Department Coordinator" && (
              <Grid
                item
                xs={12}
                sm={12}
                md={alignForAttachment ? 6 : 6}
                lg={alignForAttachment ? 6 : 6}
              >
                <FormControl component="fieldset">
                  {/*   <FormLabel
                    classes={{ asterisk: classes.asterisk }}
                    required
                    id="demo-row-radio-buttons-group-label"
                     style={{ color: "black" }}
                  >
                   
            </FormLabel>*/}
                  <Typography style={{
                    color: "black", marginTop: '-15px'
                  }}>
                    <span className={classes.asterisk}>*</span>
                    Invoice Category:
                  </Typography>
                  <RadioGroup
                    row
                    aria-label="gender"
                    name="gender1"
                    value={formState.invoiceCategory}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                  // value={value}
                  // onChange={handleChange2}
                  >
                    <FormControlLabel
                      value="Travel:Dial a car/Hotel(selected)"
                      control={<Radio size="small" />}
                      label="Travel:Dial a car/Hotel(selected)"
                      style={{ color: "black" }}
                      disabled={
                        selectedRole === "Loam Approver" ||
                        selectedRole === "TaxTeam" ||
                        selectedRole === "IP" ||
                        selectedRole === "Buyer"
                      }
                    />
                    <FormControlLabel
                      value="Brand Related Expense"
                      control={<Radio size="small" />}
                      label="Brand Related Expense"
                      style={{ color: "black" }}
                      disabled={
                        selectedRole === "Loam Approver" ||
                        selectedRole === "TaxTeam" ||
                        selectedRole === "IP" ||
                        selectedRole === "Buyer"
                      }
                    />
                    {selectedRole === "TaxTeam" ||
                      selectedRole === "Loam Approver" ||
                      selectedRole === "IP" ||
                      selectedRole === "Buyer" ? (
                      <FormControlLabel
                        value="Other"
                        control={<Radio size="small" />}
                        label="Other"
                        style={{ color: "black" }}
                        disabled={
                          selectedRole === "Loam Approver" ||
                          selectedRole === "TaxTeam" ||
                          selectedRole === "IP" ||
                          selectedRole === "Buyer"
                        }
                      />
                    ) : (
                      ""
                    )}
                  </RadioGroup>
                </FormControl>
              </Grid>
            )}
        </>
      ) : (
        ""
      )}

      {selectedRole === "Logistic" || formState.isLogistics ? (
        //  DN Invoices / ITN Invoices
        <Grid
          item
          xs={12}
          sm={12}
          md={alignForAttachment ? 6 : 4}
          lg={alignForAttachment ? 6 : 4}
        >
          <FormControl component="fieldset">
            <FormLabel
              required
              classes={{ asterisk: classes.asterisk }}
              id="demo-row-radio-buttons-group-label"
              style={{ color: "black", marginTop: '-10px' }}
            >
              <b>DN Invoices / ITN Invoices</b>
            </FormLabel>
            <RadioGroup
              row
              aria-label="gender"
              name="gender1"
              value={formState?.invoice_Type}
              aria-labelledby="demo-row-radio-buttons-group-label"
            // onChange={handleChange2}
            >
              <FormControlLabel
                value="DN"
                control={<Radio size="small" />}
                label="DN Invoices"
                disabled={selectedRole === "Logistic"}
                style={{ color: "black" }}
              />
              <FormControlLabel
                value="ITN"
                control={<Radio size="small" />}
                label="ITN Invoices"
                disabled={selectedRole === "Logistic"}
                style={{ color: "black" }}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      ) : (
        ""
      )}
    </Grid>
  );
};

export default InvoiceRadioButtons;
